import React, { FC } from "react";
import { Link } from "../../AVCore/Link";
import * as AV from "../../AVCore/AVCore";
import LogoSvg from "../../assets/images/Actavivo-Logo.svg";
import { Profile } from "../../assets/icons/icon-assets";
import { Box } from "native-base";

interface Props {
	width: any;
	height: any;
	link: AV.ILink;
}
const ProfilePic: FC<Props> = ({ width, height, link }) => {
	let uri = Link.getTummb(link);
	if (link?.id === AV.Person.self()?.id) {
		let link = AV.Person.getLink(AV.Person.self());
		uri = Link.getTummb(link);
	}
	return (
		<Box width={width} height={height}>
			{uri && <img src={uri} style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
			{!uri && <img src={LogoSvg} style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
			{/*{!uri && <Profile height="100%" width="100" color="#32AE78" />}*/}
		</Box>
	);
};
export default ProfilePic;
